@if (isRuleExpanded()) {
  <div class="camera-sequence">
    <div class="camera-sequence__header">
      <div class="camera-sequence__header-info">
        <div class="camera-sequence__header-space"></div>
        <div class="camera-sequence__legend">
          <div class="camera-sequence__legend-fix"></div>
          <span>Fix</span>
          <div class="camera-sequence__legend-offset"></div>
          <span>Offset</span>
        </div>
      </div>
    </div>
    <ng-container>
      <rc-camera-preview
        [timeInterval]="timeInterval()"
        [onTime]="onTime()"
        [offset]="offset()"
        [cycleTime]="cycleTime()"
        [ruleIndex]="ruleIndex()"
        [startDate]="startDate()"
        [photoCount]="photoCount()"
        [pictureInterval]="pictureInterval()"
        [videoLength]="videoLength()"
        [mode]="mode()"
        [trigger]="trigger()"
      ></rc-camera-preview>
      @if (!readonly() && isPreviwable()) {
        <rc-schedule-range-slider
          [offset]="offset()"
          [duration]="onTime() / 60"
          [periodLength]="cycleTime() / 60"
          [maxOffset]="1440"
          [startDate]="startDate()"
          (valueChange)="onSliderValueChange($event)"
        ></rc-schedule-range-slider>
      }
    </ng-container>
  </div>
}
